{
  "CustomisePopupTitle": "Personnaliser le rôle de l'administrateur",
  "FooterActionsSubmit": "Soumettre",
  "FooterActionsCancel": "Annuler",
  "FooterActionsHelp": "De l'aide ?",
  "TableHeadingAdminAccess": "Accès à l'administration",
  "HeadingAdministrate": "Administrer",
  "HeadingView": "Voir",
  "HeadingAdd": "Ajouter",
  "HeadingModify": "Changement",
  "HeadingDelete": "Supprimer",
  "EntryCme": "Gestion de la FMC",
  "EntryDevices": "Dispositifs",
  "EntryDevicesSub": "(Extensions \/ Groupes \/ Autres appareils)",
  "EntryAgents": "Agents",
  "EntryDirectory": "Annuaires",
  "EntryApplicationUsers": "Utilisateurs des applications",
  "EntryCodes": "Codes",
  "EntryTelServers": "Serveurs de téléphonie",
  "EntryPartition": "Cloisons",
  "EntryOmnichannel": "Omnichannel",
  "EntryRecordings": "Enregistrement",
  "EntryMessages": "Messages",
  "EntryDatabase": "Base de données",
  "TableHeadingStatusTools": "Accès au statut et aux outils",
  "HeadingSection": "Section",
  "EntryLicences": "Licences",
  "EntryLogging": "Enregistrement",
  "EntryLogManagement": "Gestion des journaux",
  "EntryAuditTrail": "Piste d'audit",
  "EntryTelephoneModuleStatus": "État du module téléphonique",
  "EntryOmnichannelStatus": "Statut omnicanal",
  "EntryCallControl": "Contrôle des appels",
  "EntryServerStatus": "Statut du serveur",
  "TableHeadingActions": "Actions",
  "HeadingAction": "Action",
  "HeadingAllowed": "Autorisé",
  "EntryCopyReportsTo": "La copie relève de...",
  "EntrySignInAs": "Se connecter en tant que...",
  "EntryBillingFilesDownload": "CDR de facturation",
  "EntryBillingSummary": "Résumé de la facturation",
  "EntryChangeLicenceLevel": "Changement de niveau de licence",
  "SyncPartition": "Partition de synchronisation",
  "ViewChangedWarning": "Sans l'option View, {} ne peut être {} qu'en utilisant l'API.",
  "Update": "actualisé",
  "Delete": "supprimé",
  "ViewChangeOr": " ou ",
  "CustomiseRole_Add": "ajouté",
  "NAME": "CustomiseRole",
  "EntryUserRole": "Rôles des utilisateurs",
  "EntryChangeTelephonyServerBillingStatus": "Modifier le statut de facturation du serveur de téléphonie",
  "EptAccess": "Outil de provisionnement facile",
  "EntryLogFilesDownload": "Télécharger les fichiers journaux",
  "TelSysSyncRestrictions": "Modifier les paramètres de synchronisation maximum",
  "CMEBrandingConfig": "Configuration de la marque CME",
  "EntryCrm": "Gestion CRM",
  "EntryClientConfig": "Configuration du client",
  "EditOwningCMEDomainProfile": "Modifier le profil du domaine CME",
  "EditOwningCMEBranding": "Modifier l'image de marque CME",
  "EditOwningCMEProvisioning": "Modifier le provisionnement CME (synchronisation du Service Pack)"
}